<template>
    <footer class="page-footer">
        <div
            v-if="getMenuIdFromType('footer')"
            v-bind:class="generateClassForMenu(getMenuIdFromType('footer'))"
        >
            <div class="footer-outer-container bg-color-footer color-footer">
                <div class="footer-container container__boxed">
                    <div class="menu-footer-inner flex--wrap">
                        <div
                            class="footer__stamps"
                            v-if="
                                certificatePreviewItems &&
                                    Array.isArray(certificatePreviewItems) &&
                                    certificatePreviewItems.length > 0
                            "
                        >
                            <div class="footer__stamp-list">
                                <component
                                    :is="
                                        items__value.data.linkActive && items__value.data.link
                                            ? 'a'
                                            : 'div'
                                    "
                                    class="footer__stamp-item"
                                    v-for="items__value in certificatePreviewItems"
                                    v-bind:key="items__value.id"
                                    v-bind:href="items__value.data.link"
                                    v-bind:target="'_blank'"
                                    v-bind:data-valid-until="items__value.data.expires"
                                >
                                    <app-moduleimage
                                        :v-if="items__value.data && items__value.data.image"
                                        :data="items__value.data.image"
                                        :tag="'img'"
                                        :height="55"
                                        :custom-class="'footer__stamp-item-image'"
                                    ></app-moduleimage>
                                    <div
                                        class="footer__stamp-item-title"
                                        v-if="items__value.data && items__value.data.name"
                                        v-html="items__value.data.name"
                                    ></div>
                                </component>
                            </div>
                        </div>

                        <div class="footer__copyright-text">
                            © {{ getProp('deha.user.firma1') }}
                            {{ getProp('deha.user.misc.firmierung') }} {{ getDate }}. Alle Rechte
                            vorbehalten.
                        </div>

                        <template
                            v-if="
                                [2].includes(((getMenuFromType('footer') || {}).layout || {}).type)
                            "
                        >
                            <div class="footer__company-details">
                                <ul class="footer__company-details-list">
                                    <li class="footer__company-details-item" v-if="data('firma1')">
                                        {{ data('firma1') }}
                                    </li>
                                    <li
                                        class="footer__company-details-item"
                                        v-if="misc('firmierung')"
                                    >
                                        {{ misc('firmierung') }}
                                    </li>
                                    <li class="footer__company-details-item" v-if="data('strasse')">
                                        {{ data('strasse') }}
                                    </li>
                                    <li
                                        class="footer__company-details-item"
                                        v-if="data('plz') && data('ort')"
                                    >
                                        {{ data('plz') }} {{ data('ort') }}
                                    </li>
                                    <li class="footer__company-details-item" v-if="data('land')">
                                        {{ data('land') }}
                                    </li>
                                </ul>
                                <ul class="footer__company-details-list">
                                    <li class="footer__company-details-item" v-if="data('telefon')">
                                        Telefon:
                                        <a
                                            :href="'tel:' + data('telefon')"
                                            class="module__link--underlined"
                                            >{{ data('telefon') }}</a
                                        >
                                    </li>
                                    <li class="footer__company-details-item" v-if="data('fax')">
                                        Fax: {{ data('fax') }}
                                    </li>
                                    <li class="footer__company-details-item" v-if="data('email')">
                                        E-Mail:
                                        <a
                                            :href="'mailto:' + data('email')"
                                            class="module__link--underlined"
                                            >{{ data('email') }}</a
                                        >
                                    </li>
                                    <app-emergencyphone
                                        custom-tag="li"
                                        custom-class="footer__company-details-item font-bold"
                                    ></app-emergencyphone>
                                </ul>
                            </div>
                        </template>

                        <ul class="footer__links flex--nowrap">
                            <li
                                v-for="items__value in items"
                                v-bind:key="items__value.id"
                                class="footer__link-item"
                            >
                                <router-link
                                    v-bind:to="'/' + $route.name + items__value.slug"
                                    class="page-footer__link color-footer module__link--underlined"
                                    exact
                                    active-class="page-footer__link--active color-footer-link-active font-bold"
                                    exact-active-class="page-footer__link--active color-footer-link-active font-bold"
                                    >{{ items__value.name }}</router-link
                                >
                            </li>
                        </ul>

                        <app-modulebackground
                            :menu-id="getMenuIdFromType('footer')"
                        ></app-modulebackground>
                    </div>
                </div>
            </div>
        </div>

        <app-configbar
            v-if="editorMode"
            :show-data="false"
            :show-layout="true"
            :show-appearance="true"
            :slim="true"
            v-on:open="toggleActive($event)"
        >
        </app-configbar>
    </footer>
</template>

<script>
import { toArray } from '@/helpers/utils';
import { mapGetters } from 'vuex';
import ModuleBackground from '@/components/assorted/ModuleBackground';
import EmergencyPhone from '@/components/assorted/EmergencyPhone';
import Configbar from '@/components/assorted/Configbar.vue';
import ModuleImage from '@/components/assorted/ModuleImage';

export default {
    data() {
        return {};
    },
    components: {
        'app-modulebackground': ModuleBackground,
        'app-emergencyphone': EmergencyPhone,
        'app-configbar': Configbar,
        'app-moduleimage': ModuleImage
    },
    methods: {
        toggleActive(configurator_view) {
            if (this.getActiveConfiguratorView === configurator_view) {
                this.$router.push({ name: 'editor', params: { page: this.getActivePageRoute } });
            } else {
                this.$router.push({
                    name: 'editor',
                    params: { page: this.getActivePageRoute },
                    query: {
                        configurator: 1,
                        configurator_group: 'menus',
                        configurator_view: configurator_view,
                        menu_id: this.getMenuIdFromType('footer')
                    }
                });
            }
        },
        data(prop) {
            return this.getProp('deha.user.' + prop);
        },
        misc(prop) {
            return this.getProp('deha.user.misc.' + prop);
        }
    },
    computed: {
        ...mapGetters([
            'getPages',
            'getActiveConfiguratorView',
            'getMenuIdFromType',
            'getActivePageRoute',
            'editorMode',
            'generateClassForMenu',
            'getMenuFromType',
            'getProp',
            'getMenuBackground',
            'getListItems',
            'getRandomImageInNamespace'
        ]),
        items() {
            return toArray(this.getPages)
                .filter((i) => i.visible)
                .filter((i) => i.menu_id === this.getMenuIdFromType('footer'))
                .sort((a, b) => a.pos - b.pos);
        },
        certificatePreviewItems() {
            return toArray(this.getListItems('deha.user.misc.certifications'))
                .filter((i) => (i.data && i.data.footerPreview ? i.data.footerPreview : false))
                .sort((a, b) => a.pos - b.pos);
        },
        getDate() {
            return new Date().getFullYear();
        }
    },
    created() {},
    props: {}
};
</script>
